@if (routerLink) {
  <a (click)="handleClick($event)"
     [ngClass]="{
        'small': size === 'small',
        'disabled': disabled,
        'floating': floating,
        'with-icon': iconName,
        'icon-right': iconPositionRight,
        'icon-only': iconOnly,
        'no-text': text==='',
        'white': whiteBackground,
        'full-width': fullWidth,
        'full-width-mobile': fullWidthMobile,
        'loading' : loadingState === 'loading',
        'align-right' : alignRight,
        'align-center' : alignCenter,
        'transitions' : initFinished,
        'active' : active,
        'link-style' : linkStyling,
        'font-weight--regular': fontWeight === 'regular',
        'align-column': alignColumn()
        }"
     [queryParams]="queryParams ? queryParams : undefined"
     [routerLink]="(routerLink && !disabled) ? routerLink : undefined"
     [style.height]="width && iconOnly ? (width + 'px') : (height() ? (height() + 'px') : null)"
     [style.max-width]="maxWidth ? maxWidth + 'px' : null"
     [style.padding]="iconPadding + 'px'"
     [style.width]="width? width + 'px': null"
     [type]="type"
     [workUiTooltip]="tooltipDescription | translate"
     ariaCurrentWhenActive="page"
     class="work-ui-button work-button {{variant}}"
     routerLinkActive="active-page"
     data-testid="routerLink">
    <ng-template [ngTemplateOutlet]="innerButton"></ng-template>
  </a>
} @else {
  @if (htmlLink) {
    <a (click)="handleClick($event)"
       [download]="fileDownloadName"
       [href]="htmlLink"
       [ngClass]="{
        'small': size === 'small',
        'disabled': disabled,
        'floating': floating,
        'with-icon': iconName,
        'icon-right': iconPositionRight,
        'icon-only': iconOnly,
        'no-text': text==='',
        'white': whiteBackground,
        'full-width': fullWidth,
        'full-width-mobile': fullWidthMobile,
        'loading' : loadingState === 'loading',
        'align-right' : alignRight,
        'align-center' : alignCenter,
        'transitions' : initFinished,
        'active' : active,
        'link-style' : linkStyling,
        'font-weight--regular': fontWeight === 'regular',
        'align-column': alignColumn()
        }"
       [style.height]="width && iconOnly ? (width + 'px') : (height() ? (height() + 'px') : null)"
       [style.max-width]="maxWidth ? maxWidth + 'px' : null"
       [style.padding]="iconPadding + 'px'"
       [style.width]="width? width + 'px': null"
       [target]="htmlLinkOpenNewTab ? '_blank' : ''"
       [type]="type"
       [workUiTooltip]="tooltipDescription | translate"
       class="work-ui-button work-button {{variant}}"
       data-testid="htmlLink">
      <ng-template [ngTemplateOutlet]="innerButton"></ng-template>
    </a>
  } @else {
    <button (click)="!disabled ? handleClick($event) : undefined"
            [disabled]="disabled"
            [ngClass]="{
              'small': size === 'small',
              'floating': floating,
              'with-icon': iconName,
              'icon-right': iconPositionRight,
              'icon-only': iconOnly,
              'no-text': text==='',
              'white': whiteBackground,
              'full-width': fullWidth,
              'full-width-mobile': fullWidthMobile,
              'loading' : loadingState === 'loading',
              'align-right' : alignRight,
              'align-center' : alignCenter,
              'transitions' : initFinished,
              'active' : active,
              'font-weight--regular': fontWeight === 'regular',
              'align-column': alignColumn()
            }"
            [style.height]="width && iconOnly ? (width + 'px') : (height() ? (height() + 'px') : null)"
            [style.max-width]="maxWidth ? maxWidth + 'px' : null"
            [style.padding]="iconPadding + 'px'"
            [style.width]="width? width + 'px': null"
            [type]="type"
            [workUiTooltip]="tooltipDescription | translate"
            class="work-ui-button work-button {{variant}}"
            data-testid="button">
      <ng-template [ngTemplateOutlet]="innerButton" />
    </button>
  }
}



<ng-template #innerButton>
  <span [class.hide]="loadingState !== 'none' && !!loadingState"
        [class.show]="buttonClicked && loadingState === 'none'"
        [ngClass]="iconOnly ? 'center' : 'space-between'"
        class="work-ui-button__text flex flex-row vertical-center width-100 work-loading-element show-on-init">
    @if (iconName) {
      <work-ui-icon [boldness]="400" [fontSize]="floating ? 48 : size || linkStyling ? 18 : 24" [name]="iconName"
                    class="work-text-color-unset" />
    }
    @if (iconExternalSrc) {
      <img [src]="iconExternalSrc" [alt]="'ICON' | translate">
    }
    <div class="flex flex-row gap-8 center width-100">
      <span class="work-text-overflow-ellipsis" style="margin-top: 1px;">
        @if (size === 'small') {
          <small>{{ text | translate }}</small>
        }
        @if (size !== 'small') {
          <span>{{ text | translate }}</span>
        }
      </span>
      @if (badgeValue) {
        <span class="work-badge"
              [class.work-badge--white]="variant === 'primary'">
          {{ badgeValue }}
        </span>
      }
    </div>
    <ng-content />
  </span>
  @if (loadingState !== 'none') {
    <work-ui-loading-spinner [(loadingState)]="loadingState" [iconSize]="floating ? 48 : 24" />
  }
</ng-template>
